export const shelves = [
    {
        name: 'shelf_450_300',
        height: 0.05,
        width: 0.45,
        depth: 0.3,
    },
    {
        name: 'shelf_450_400',
        height: 0.05,
        width: 0.45,
        depth: 0.4,
    },
    {
        name: 'shelf_450_500',
        height: 0.05,
        width: 0.45,
        depth: 0.5,
    },
    {
        name: 'shelf_600_300',
        height: 0.05,
        width: 0.6,
        depth: 0.3,
    },
    {
        name: 'shelf_600_400',
        height: 0.05,
        width: 0.6,
        depth: 0.4,
    },
    {
        name: 'shelf_600_500',
        height: 0.05,
        width: 0.6,
        depth: 0.5,
    },
    {
        name: 'shelf_900_300',
        height: 0.05,
        width: 0.9,
        depth: 0.3,
    },
    {
        name: 'shelf_900_400',
        height: 0.1,
        width: 0.9,
        depth: 0.4,
    },
    {
        name: 'shelf_900_500',
        height: 0.05,
        width: 0.9,
        depth: 0.5,
    },
    {
        name: 'go_45',
        height: 0.05,
        width: 0.45,
        depth: 0.5,
    },
    {
        name: 'go_60',
        height: 0.05,
        width: 0.6,
        depth: 0.5,
        rotation: [ 0, 0, 0 ],
    },

];

export const defaultShelvesOffsets = [ 0,-0.002,0.01 ] as const;
export const defaultShelvesRotation = [ 0,180,0 ] as const;
export const shelvesBracketHeight=0.07;